import { useJ1AuthFetchReturn, urls } from '@jupiterone/jupiter-web-toolkit';
import { stringify } from 'query-string';
import { UsageDataPoint } from 'navbar/src/jupiterAccountSettings/types';

export interface UsageOptions {
  timeRangeType: 'month' | 'day' | 'year';
  startTimestamp: number;
  endTimestamp: number;
  nextPageToken?: string;
}

export interface UsageDataResponse {
  data: [UsageDataPoint];
  nextPageToken: string | null;
}
export async function getUsage({
  authFetch,
  usageOptions,
}: {
  authFetch: useJ1AuthFetchReturn['authFetch'];
  usageOptions: UsageOptions;
}): Promise<UsageDataResponse> {
  const queryStringParams = stringify(usageOptions as any);
  const fullyQualifiedUrl = `${urls.usageUrl}?${queryStringParams}`;
  const response = await authFetch(fullyQualifiedUrl, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  });
  return (await response.json()) as UsageDataResponse;
}
